import { useState } from 'react';

export default function useInitialValue<T>(value: T)
{
    const [ initialValue ] = useState(value);

    return initialValue;
}
